import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const ran = useRef(false);
  const [status, setStatus] = useState("checking"); // checking | ok | error
  const [message, setMessage] = useState("Verifying your email…");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) { setStatus("error"); setMessage("This verification link is invalid."); return; }
    // Hard fallback: never leave the user stuck on the spinner.
    const guard = setTimeout(() => {
      setStatus((s) => (s === "checking" ? "error" : s));
      setMessage((m) => (m === "Verifying your email…" ? "Verification timed out. Please try the link again or resend it." : m));
    }, 12000);
    api.post("/auth/verify-email", { token })
      .then((r) => { setStatus("ok"); setMessage(r.data?.message || "Email verified. You can now sign in."); })
      .catch((e) => { setStatus("error"); setMessage(e.response?.data?.detail || "Invalid or expired verification link."); })
      .finally(() => clearTimeout(guard));
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-5 text-center gap-5"
      data-testid="verify-email-page">
      {status === "checking" && <Loader2 className="w-10 h-10 animate-spin text-primary" />}
      {status === "ok" && <CheckCircle2 className="w-12 h-12 text-primary" />}
      {status === "error" && <XCircle className="w-12 h-12 text-destructive" />}
      <p className="text-muted-foreground max-w-sm">{message}</p>
      <Button onClick={() => navigate("/login")} data-testid="verify-goto-login"
        className="rounded-full font-medium">Go to sign in</Button>
    </div>
  );
}
